/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/credit_pola_1': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M29 13.646V3H18.354L16 .646 13.646 3H3v10.646L.646 16 3 18.354V29h10.646L16 31.354 18.354 29H29V18.354L31.354 16 29 13.646zm-.5-.5V28.5h-25v-25h25v9.646z"/><path pid="1" d="M16 11.415L20.583 16 16 20.586 11.414 16z"/><path pid="2" d="M19.354 4H4v24h24V4h-8.646zm3.353 12.707L20.414 19l1.543 1.543a.999.999 0 11-1.414 1.414L19 20.414l-2.293 2.293a.997.997 0 01-1.414 0L13 20.414l-1.543 1.543a.997.997 0 01-1.414 0 .999.999 0 010-1.414L11.586 19l-2.293-2.293a.999.999 0 010-1.414L11.586 13l-1.543-1.543a.999.999 0 111.414-1.414L13 11.586l2.293-2.293a.999.999 0 011.414 0L19 11.586l1.544-1.543a.999.999 0 111.414 1.414L20.414 13l2.293 2.293a.999.999 0 010 1.414z"/>'
  }
})
